import React from 'react';
import { connect } from 'react-redux';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, oem_id, oem_model, sw_version,
} from '../../filters/filterPanel/FilterPanel';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import ValueDisplay from '../../reports/valueDisplayReport/ValueDisplayReport';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, listOfOemModels, listOfOems,
  listOfSwVersions, totalDatapoints, totalUsersWithDevices,
  devicesOnlineToday, usersActivityByLastSignIn, usersCreatedOverTime,
  usersWithDevices, contractTotalDatapointsTransactions,
} from '../../../services/reportsservice';
import './UserAnalysisPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";

class UserAnalysisPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.UserAnalysisPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return {

      filters: [
        listOfOemModels(filters),
        listOfSwVersions(filters),
        listOfOems(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ?  [
        activatedDevices(filters),
        contractTotalDatapointsTransactions(filters),
        devicesOnlineToday(filters),
        totalUsersWithDevices(filters),
        usersWithDevices(filters),
        usersActivityByLastSignIn(filters),
        usersCreatedOverTime(filters),
        ]
        : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        totalUsersWithDevices(filters),
        usersWithDevices(filters),
        usersActivityByLastSignIn(filters),
        usersCreatedOverTime(filters),
      ],
    };
  }

  reportsDescription = () => [
    usersActivityByLastSignIn(),
    usersCreatedOverTime(),
  ];


  render() {
    const { errors, fetchData, session } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);
    return (
      <div className="UserAnalysisPage page">
        <TitleBar title="userAnalysis">
          <TimeAggregation value={this.props.presistFilters.aggregate_by} />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel disabled={fetchData.fetches > 0}
            currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role) && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              sw_version(this.report(listOfSwVersions)),
            ]}
          />

          <div>
            <ValueDisplay title="users.total"
              width={this.widthForColumns(3, 1)}
              data={{
                details: {
                  'users.withDevices': getReportData(this.report(usersWithDevices),'Percentage_Of_Users_With_Devices', 'stringToPercentage'),
                },
                value: getReportData(this.report(totalUsersWithDevices),'User_Analysis_Total_Users')
              }}
            />
            <BarChart title="users.lastSignIn"
              width={this.widthForColumns(3, 2)}
              height={200}
              data={getReportData(this.report(usersActivityByLastSignIn), 'User_Activity_By_Last_Sign_In_Over_Time')}
              description={this.reportDescription(usersActivityByLastSignIn)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="usersSignin"
              skipDetailsTranslation
            />
          </div>
          <div>
            <BarChart title="users.createdOverTime"
              width={this.widthForColumns(1) - 6}
              height={200}
              data={getReportData(this.report(usersCreatedOverTime), 'Users_Created_Over_Time')}
              description={this.reportDescription(usersCreatedOverTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="users"
              skipDetailsTranslation
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(UserAnalysisPage);
